//#region src/mod_group_wallet_type.ts
var ModGroupWalletType = /* @__PURE__ */ function(ModGroupWalletType) {
	ModGroupWalletType["Quantity"] = "quantity";
	ModGroupWalletType["Dollar"] = "dollar";
	return ModGroupWalletType;
}(ModGroupWalletType || {});
//#endregion
export { ModGroupWalletType };

//# sourceMappingURL=mod_group_wallet_type.js.map